import React from 'react';

import { MobileFilter2 } from '../../../filter/MobileFilter2';
import { FinishingFilter } from '../../../../models/Filter';
import { FinishingFilterView } from '../../finishing/FinishingFilterView';

interface IFinishingFilter {
    filter: FinishingFilter;
    handleChange: (filter: FinishingFilter) => void;
    classNameGroup?: string;
}

export const ClMobileFinishingTypeFilterView: React.FC<IFinishingFilter> = ({
    filter,
    handleChange,
    classNameGroup
}) => {
    return (
        <MobileFilter2 filterTitle='Отделка'>
            <FinishingFilterView
                filter={filter}
                handleChange={handleChange}
                classNameGroup={classNameGroup}
            />
        </MobileFilter2>
    );
};
